<template>
  <div class="edit-questionaire-dialog-wrapper">
    <el-dialog class="edit-questionaire-dialog" :visible.sync="visible" append-to-body center title="设置问卷内容">
      <el-form class="edit-questionaire-form" :model="questionContent" :rules="questionaireRules" ref="questionaireRuleForm" :show-message="true">
        <el-form-item class="edit-questionaire-dialog-title" prop="formName" label="名称" label-width="60px">
          <el-input v-model="questionContent.formName" size="small"></el-input>
        </el-form-item>
        <div class="add-button" @click="handleAdd('text')">添加文本框</div>
        <div class="add-button" @click="handleAdd('radio')">添加单选</div>
        <div class="add-button" @click="handleAdd('checkbox')">添加多选</div>
      </el-form>
      <el-table :data="questionContentConstruction" style="width: 100%" max-height="290" border center :header-cell-style="setHeaderCellStyle" :cell-style="setCellStyle">
        <el-table-column fixed prop="title" label="题目名称"> </el-table-column>
        <el-table-column prop="type" label="题目类型" width="87"> </el-table-column>
        <el-table-column label="操作" width="313">
          <template slot-scope="scope">
            <div class="option-button-wrapper">
              <div class="option-button" @click="handleEdit(scope.$index, scope.row)">编辑</div>
              <div class="option-button" @click="handleMove(scope.$index, 'first')">置顶</div>
              <div class="option-button" @click="handleMove(scope.$index, 'before')">上移</div>
              <div class="option-button" @click="handleMove(scope.$index, 'next')">下移</div>
              <div class="option-button" @click="handleMove(scope.$index, 'last')">置底</div>
              <div class="option-button" @click="handleDelete(scope.$index)">删除</div>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="edit-questionaire-dialog-footer">
        <div class="edit-questionaire-dialog-footer-button cancel" @click="visible = false">取消</div>
        <div class="edit-questionaire-dialog-footer-button confirm" @click="questionaireConfirm">发布</div>
      </div>
      <div class="edit-questionaire-dialog-tip">
        读者在线问卷发布后需保存书刊设置方可生效。当修改了问卷内容发布保存后，将按照新的问卷内容进行信息收集，原问卷收集的信息仍可在问卷数据中查看，不会被删除，若未调整问卷内容，建议不要点击发布，避免保存书刊编辑内容时生成两个相同的问卷。
      </div>
    </el-dialog>
    <el-dialog v-if="questionDialogVisible" class="edit-question-dialog" :title="questionDialogTitle" :visible.sync="questionDialogVisible" center append-to-body>
      <el-form class="edit-question-form" :model="questionRuleForm" :rules="questionRules" ref="questionRuleForm" :show-message="true">
        <el-form-item class="edit-questionaire-dialog-title" prop="title" label="题目名称" label-width="80px">
          <el-input v-model="questionRuleForm.title" maxlength="300" size="small"></el-input>
        </el-form-item>
        <el-form-item label="" label-width="80px">
          <el-checkbox class="require-checkbox" v-model="questionRuleForm.requirement">必填项</el-checkbox>
        </el-form-item>
        <el-form-item v-if="questionRuleForm.questionType !== 'text'" prop="options" label="题目选项" label-width="80px">
          <el-input type="textarea" :rows="7" maxlength="300" placeholder="请输入选项，并用回车区分不同选项" v-model="questionRuleForm.options"> </el-input>
        </el-form-item>
      </el-form>
      <div class="edit-questionaire-dialog-footer">
        <div class="edit-questionaire-dialog-footer-button cancel" @click="questionCancel">取消</div>
        <div class="edit-questionaire-dialog-footer-button confirm" @click="questionConfirm">保存</div>
      </div>
    </el-dialog>
    <TipDialog ref="deleteDialog" :dialogOptions="deleteDialogOptions" :appendToBody="true" @clickCancel="deleteCancel" @clickConfirm="deleteConfrim"></TipDialog>
  </div>
</template>
<script>
import TipDialog from '@components/common/TipDialog.vue'
import { isSimpleIllegalWord } from '@utils'

export default {
  name: 'editQuestionaireDialog',
  data() {
    var checkName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('必须填写所有题目设置'))
      } else if (isSimpleIllegalWord(value)) {
        return callback(new Error('名称不能含有特殊字符'))
      } else {
        callback()
      }
    }
    var checkOptions = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('必须填写所有题目设置'))
      } else if (isSimpleIllegalWord(value)) {
        return callback(new Error('名称不能含有特殊字符'))
      } else {
        callback()
      }
    }

    return {
      questionIndex: -1, // 添加操作 -1 ，编辑、删除操作 当前index
      visible: false,
      questionDialogVisible: false,
      questionTypeTitleMap: {
        text: { title: '文本框设置', type: '文本', order: 1 },
        radio: { title: '单选设置', type: '单选', order: 1 },
        checkbox: { title: '多选设置', type: '多选', order: 1 }
      },
      questionaireRuleForm: {
        title: ''
      },
      questionaireRules: {
        // formName: [{ required: true, message: '不能为空' }]
      },
      questionRuleForm: { type: '', title: '', requirement: '', options: '', questionType: '' }, // questionType: 'text', // text/radio/checkbox
      questionRules: {
        title: [{ validator: checkName, trigger: 'blur' }],
        options: [{ validator: checkOptions, trigger: 'blur' }]
      },
      deleteDialogOptions: {
        // 弹框类型
        type: 'delete',
        // 弹框头部标题
        title: '提示',
        // 弹框内容
        tip: '题目删除后无法恢复，是否确认删除？'
      }
    }
  },
  props: {
    type: {
      type: String,
      default: 'book'
    }
  },
  computed: {
    questionDialogTitle() {
      return this.questionTypeTitleMap[this.questionRuleForm.questionType].title
    },
    questionContentConstruction: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].questionContentConstruction || null
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionContentConstruction', value: value })
      }
    },
    questionContent: {
      get: function() {
        return this.$store.state.config[this.type + 'Obj'].questionContent || null
      },
      set: function(value) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE', { type: this.type + 'Obj', key: 'questionContent', value: value })
      }
    }
  },
  methods: {
    setHeaderCellStyle(options) {
      if (options.columnIndex !== 0) {
        return { 'background-color': '#fafafa', 'text-align': 'center', color: '#333' }
      } else {
        return { 'background-color': '#fafafa', color: '#333' }
      }
    },
    setCellStyle(options) {
      if (options.columnIndex !== 0) {
        return 'text-align: center'
      }
    },
    handleAdd(questionType) {
      if (this.questionContentConstruction.length >= 20) {
        this.$message({ message: '题目数量已达到最大值，无法新增题目', type: 'warning' })
        return
      }
      this.questionIndex = -1
      // 新增需重置数据
      this.questionRuleForm = { type: '', title: '', requirement: '', options: '', questionType: '' }
      this.questionRuleForm.questionType = questionType
      // 默认名称
      this.questionRuleForm.title = `${this.questionTypeTitleMap[questionType].type}${this.questionTypeTitleMap[questionType].order}`
      this.questionDialogVisible = true
    },
    handleEdit(index, row) {
      this.questionIndex = index
      this.questionRuleForm = JSON.parse(JSON.stringify(this.questionContentConstruction[index]))
      this.questionDialogVisible = true
    },
    handleMove(index, type) {
      let currentValue = this.questionContentConstruction[index]
      let displaceIndex = 0
      switch (type) {
        case 'first':
          if (index > 0) {
            this.questionContentConstruction.splice(index, 1)
            this.questionContentConstruction.unshift(currentValue)
          }
          break
        case 'last':
          if (index < this.questionContentConstruction.length - 1) {
            this.questionContentConstruction.splice(index, 1)
            this.questionContentConstruction.push(currentValue)
          }
          break
        case 'before':
          displaceIndex = index === 0 ? 0 : index - 1
          if (index !== displaceIndex) {
            this.$set(this.questionContentConstruction, index, this.questionContentConstruction[displaceIndex])
            this.$set(this.questionContentConstruction, displaceIndex, currentValue)
          }
          break
        case 'next':
          displaceIndex = index === this.questionContentConstruction.length - 1 ? this.questionContentConstruction.length - 1 : index + 1
          if (index !== displaceIndex) {
            this.$set(this.questionContentConstruction, index, this.questionContentConstruction[displaceIndex])
            this.$set(this.questionContentConstruction, displaceIndex, currentValue)
          }
          break
      }
    },
    handleDelete(index) {
      this.questionIndex = index
      this.$refs.deleteDialog.visible = true
    },
    deleteCancel() {
      this.$refs.deleteDialog.visible = false
    },
    deleteConfrim() {
      this.questionContentConstruction.splice(this.questionIndex, 1)
      this.questionIndex = -1
    },
    questionaireConfirm() {
      if (this.questionContentConstruction && this.questionContentConstruction.length > 0) {
        this.$store.commit('config/UPDATE_QUESTIONAIRE_FLAG', true)
        this.$store.commit('config/UPDATE_IS_PUBLISH', true)
        this.visible = false
      } else {
        this.$message({ message: '请完成读者在线问卷设置', type: 'error' })
      }
    },
    questionConfirm() {
      this.$refs.questionRuleForm.validate((valid, data) => {
        if (valid) {
          this.questionTypeTitleMap[this.questionRuleForm.questionType].order++
          const type = this.questionTypeTitleMap[this.questionRuleForm.questionType].type
          if (this.questionIndex === -1) {
            this.questionContentConstruction.push({ ...this.questionRuleForm, type })
          } else {
            this.$set(this.questionContentConstruction, this.questionIndex, { ...this.questionRuleForm, type })
          }
          this.questionDialogVisible = false
        } else {
          if (data.title) {
            this.$alert(data.title[0].message, '提示', {
              confirmButtonText: '确定'
            })
          } else {
            this.$alert(data.options[0].message, '提示', {
              confirmButtonText: '确定'
            })
          }
        }
      })
    },
    questionCancel() {
      this.$store.commit('config/UPDATE_IS_PUBLISH', false)
      this.questionDialogVisible = false
    }
  },
  mounted() {
    this.$store.commit('config/UPDATE_IS_PUBLISH', false)
    if (!this.questionContent.formName) {
      this.questionContent.formName = this.$store.state.config.bookObj.shareTitle + '问卷'
    }
  },
  components: {
    TipDialog
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-textarea {
  textarea {
    resize: none;
  }
}
.edit-questionaire-dialog {
  /deep/ .el-dialog {
    width: 700px;
    .el-dialog__body {
      padding: 25px 50px 30px;
    }
  }
  /deep/ .el-input {
    width: 190px;
  }
  .edit-questionaire-dialog-title {
    display: inline-block;
    width: 248px;
  }
  .add-button {
    display: inline-block;
    width: 100px;
    height: 30px;
    line-height: 30px;
    background-color: #df5813;
    color: #fff;
    text-align: center;
    margin-left: 10px;
    cursor: pointer;
  }
  .option-button-wrapper {
    display: inline-flex;
    padding: 0 30px;
    justify-content: space-between;
    width: 100%;
    .option-button {
      color: #df5813;
      cursor: pointer;
      display: inline-block;
    }
  }
  .edit-questionaire-dialog-tip {
    background-color: #fff7ed;
    color: #df5813;
    height: 76px;
    font-size: 12px;
    padding: 12px 16px 12px 20px;
    margin-top: 27px;
  }
}
.edit-questionaire-dialog-footer {
  text-align: center;
  margin: 35px 0 27px 0;
  .edit-questionaire-dialog-footer-button {
    width: 110px;
    height: 38px;
    color: #fff;
    line-height: 38px;
    display: inline-block;
    cursor: pointer;
    &.cancel {
      background-color: #999;
      margin-right: 28px;
    }
    &.confirm {
      background-color: #df5813;
    }
  }
}
.edit-question-dialog {
  /deep/ .el-input,
  .el-textarea {
    width: 180px;
  }
  .edit-question-form {
    width: 260px;
    margin: 0 auto;
  }
}
</style>
